import {
  Button,
  Checkbox,
  FormControlLabel
  // FormHelperText
} from '@mui/material';
import React, { MouseEventHandler } from 'react';

import ModalComponent from '../modal-component';
import { toTitle } from '../utils';

interface TableColumnModalProps {
  columnProps: any;
  handleHideModal: () => void;
  handleToggleColumn: (a: any) => void;
  showModal: boolean;
}

const TableColumnModal = React.memo(function TableColumnModal({
  columnProps,
  handleHideModal,
  handleToggleColumn,
  showModal
}: TableColumnModalProps) {
  return (
    <ModalComponent showModal={showModal} closeModal={handleHideModal}>
      <div className="column-toggle">
        <div className="column-toggle-header">
          <div>
            <h4>Toggle Visible Columns</h4>
            <a onClick={handleToggleColumn}>Select All</a>
            <a onClick={handleToggleColumn}>Deselect All</a>
          </div>
        </div>

        <div className="checkboxes">
          { columnProps.map((property, idx) => (
            <div key={idx} className="checkbox-container">
              <FormControlLabel
                key={idx}
                control={
                  <Checkbox
                    className="toggle-field-checkbox"
                    checked={property.indexView || false}
                    onChange={handleToggleColumn}
                    value={property.key}
                  />
                }
                label={property.label || toTitle(property.key)}
              />
              { /* <FormHelperText className="checkbox-label-sub">{property.description}</FormHelperText> */ }
            </div>
          )) }
        </div>

        <div className="column-toggle-footer">
          <Button onClick={handleHideModal} variant="contained">
            Save Changes
          </Button>
        </div>
      </div>
    </ModalComponent>
  );
});

export default TableColumnModal;
